/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import get from 'lodash/get';
import moment from 'moment';

export function getAccountTypeSelector(account, facilityId) {
    if (account?.is_commercial_account) {
        // note: if facility is empty then the expectation is that we return FIT
        const availablePermit = get(account, ['special_use_permits', facilityId]);

        // if the permit is available then it cannot be suspended or expired
        if (
            availablePermit &&
            !availablePermit.is_suspended &&
            moment(availablePermit.expiration).isAfter(moment())
        ) {
            return 'COMM';
        }
    }
    return 'FIT';
}
